import { Link } from 'react-router-dom'
import { ArrowLeft, Image } from 'lucide-react'
import * as stylex from '@stylexjs/stylex'
import { TextToImageGallery } from '@/components/gallery/TextToImageGallery'
import { TextImageToImageGallery } from '@/components/gallery/TextImageToImageGallery'
import { ImageGalleryItem } from '@/models/gallery'
import { styles } from '@/styles/ImagePage.stylex'

// Model configuration - single source of truth
const MODEL_CONFIG = {
    name: 'Google Imagen',
    shortName: 'Google Imagen',
    modelKey: 'google-imagen',
    creditsPerImage: 4,
    heroBgImage: 'https://cdn.aibrush.co/docs/images/models/google-imagen/image-hero.png',
    providerUrl: 'https://imagen.research.google/',
    providerName: 'Google',
    pageUrl: 'https://docs.aibrush.co/images-models/google-imagen',
} as const;

const textToImageGalleryItems: ImageGalleryItem[] = [
    {
        id: "google-imagen-1",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-1.png",

        prompt: "A brunette woman with freckles; I want her to be very realistic, set in an ambiance of pastel tones and a dreamy atmosphere. She should be on an ultra‑luxurious wooden yacht with large windows.",

    },
    {
        id: "google-imagen-2",
        width: 1536,
        height: 2816,
        aspect_ratio: "9:16",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-2.png",
        variant: 'tall',
        prompt: "A full slice of chocolate cake, shown entirely in frame, placed on an elegant porcelain plate. Instead of powdered sugar, the rim of the plate is decorated with tiny sparkling diamonds that glisten delicately. The cake's frosting is made of dazzling gemstones and diamonds that shine like a starry night sky. Resting on the plate is an elegant polished metal spoon that completes the context. Fine crumbs and glossy chocolate textures rendered in hyper realism. Hyper realistic, ultra detailed, cinematic photographic lighting, perfect depth of field, looks like a movie frame."
    },
    {
        id: "google-imagen-3",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-3.png",
        variant: 'wide',
        prompt: "create a double exposure of a close up of a drivers racing helmet and an shot of formula 1 race cars"
    },
    // {
    //     id: "google-imagen-4",
    //     width: 2816,
    //     height: 1536,
    //     src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-4.png",
    //     className: "gallery-item featured",
    //     prompt: "Daenerys Targaryen standing on a cliff with her dragons circling above, wind blowing her white hair, dramatic cloudy sky, epic high-fantasy cinematic style"
    // },
    {
        id: "google-imagen-5",
        width: 1536,
        height: 2816,
        aspect_ratio: "9:16",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-5.png",
        variant: 'tall',
        prompt: "The tiniest, cutest hedgehog in the world, sitting on top of my finger,Eating strawberry toast,hapiness,Big smile at the end. Hyper-realistic photography"
    },

    {
        id: "google-imagen-6",
        width: 1536,
        height: 2816,
        aspect_ratio: "9:16",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-6.png",
        variant: 'tall',
        prompt: "Realistic portrait of a smiling white red-headed Female model as a high-fashion model on the cover of a magazine. The girl is dressed in a soft and feathered white turtleneck sweater, she has box braids, There stands 'AiBrush' on the title."
    },
    {
        id: "google-imagen-12",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-12.png",
        variant: 'featured',
        prompt: "poster promoting the play murder by design 1920's fashion with lace and pearls with a hand gun and tea cup sitting on a table"
    },
    {
        id: "google-imagen-7",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-7.png",

        prompt: "Surrealist artwork, The eyes in television all flash or shift focus in a different way. The television in blank space blinks and turns on and off as if it is broken. Mushrooms are on the Television"
    },
    {
        id: "google-imagen-8",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-8.png",
        variant: 'wide',
        prompt: "Full-length model in long earthy red dress, with thin belt, black hat and boots, leading a sleek horse; dress trailing in wind; low 35-45mm, above eye-level, side sunlight or hard key 45°, shadows clean, desert as a backdrop, decisive stride"
    },
    {
        id: "google-imagen-9",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-9.png",

        prompt: "Close-up, fisheye shot. An orange cat wearing a colorful hoosweatshirt and a gold chain is driving a retro blue-green convertible through a bustling coastal street in Seoul, South Korea. On a sunny day, it's fashionable and fun."
    },
    {
        id: "google-imagen-10",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-10.png",

        prompt: "Painting a sumi-e painting of a Japanese samurai"
    },
    {
        id: "google-imagen-11",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-11.png",

        prompt: "film photo of a giant historical city,megalopolis,brutalism architecture,gothic,church,giant parabolic antennas,mystic vibe, grunge tones, realistic, photorealistic,kodak VISION3 500T , filmic, cinematic, 2.35, film still, shot, beautiful, cinematic lighting, taken by a disposable camera, psychological horror movie, Directed by Ari Aster,"
    },

    {
        id: "google-imagen-13",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-13.png",

        prompt: "a young boy made out of clay, very high end imagry for movies, our main charater is at home sitting on his bed, the room is vibrantly decorated in dogers baseball fandome a cute dog is curled up at his feet. He is taking an online survey on his desktop and cursing."
    },
    {
        id: "google-imagen-14",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-14.png",

        prompt: "A cute woman is walking on the road, listening to music with headphones and smiling happily. The background features blurred green plants and flowers. Children's simple drawings, minimalist lines, white lines, thick lines, brighter glowing outlines on the character. Musical notes are floating around her head, adding an artistic touch to the entire scene. Her whole body is depicted using a minimalist style, giving people warm feelings."
    },
    {
        id: "google-imagen-15",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-15.png",

        prompt: "a female dark knight walks towards the camera; her blade flaming; her hair blows slightly in the breeze; she gently raises her wings"
    },
    {
        id: "google-imagen-21",
        width: 1536,
        height: 2816,
        aspect_ratio: "9:16",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-21.png",
        variant: 'tall',
        prompt: "Two small humanoid figures made entirely of water, with liquid-like translucent bodies, playing soccer on top of a smooth rock in the middle of a flowing river. The river sparkles under soft natural light, with ripples and splashes around the rock. The scene is dynamic, whimsical, and surreal capturing both the playful energy of the game and the fluid nature of the water beings."
    },
    {
        id: "google-imagen-16",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-16.png",

        prompt: "Render a raw, analog-style street photo of a BMX rider caught mid-air above a staircase handrail. The environment shows signs of urban decay chipped walls, rust-streaked railings, and scattered leaves. The light is diffused through trees, with analog imperfections like grain, halation, and soft bloom enhancing the nostalgic feel. The composition feels spontaneous, as if shot on 35mm film. Use a Gritty Analog Film Style with tactile realism."
    },
    {
        id: "google-imagen-17",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-17.png",

        prompt: "A surreal scene on the Moon. A small astronaut in a shiny white space suit sits relaxed inside a tiny pool of water, as if it's a playful bathtub, but not an actual bathtub. The surface of the Moon is gray and dusty, with a realistic Earth glowing in the black sky above. Cinematic, whimsical, surreal mood. Playful but epic lighting, highly detailed, ultra-realistic textures, 8k, dramatic composition."
    },

    {
        id: "google-imagen-18",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-18.png",

        prompt: "Air Leaf aerosol spray can, matte light gray with emerald and aqua blue accents, minimal leaf + airflow icon, futuristic bold typography 'Air Leaf', premium eco-tech cleaning product design, photorealistic studio render, bright fresh background"
    },
    {
        id: "google-imagen-19",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-19.png",

        prompt: "A full-body photo of an adorable cat wearing a beret, on a vintage book page background, in the style of Beatrix Potter, in a watercolor sketch style, with clear edges, in white and gray, with blue eyes, black stripes, and a blue nose. The cat has a little bit of blue in its eye and a beautiful, big, expressive, and sweet face. The background features the city of Paris, in a clipart, vector illustration, detailed design, and watercolor style."
    },
    {
        id: "google-imagen-20",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-20.png",

        prompt: "An M.C. Escher inspired impossible staircase, surreal architecture, optical illusion, infinite geometry, hyper detailed, black and white, high contrast"
    },
    {
        id: "google-imagen-22",
        width: 1536,
        height: 2816,
        aspect_ratio: "9:16",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-22.png",
        variant: 'tall',
        prompt: "A crowded city street. Suddenly, a gigantic glowing peach bomb falls from the sky and crashes onto the ground with a dramatic impact. From the explosion, radiant peach-colored energy bursts outward in every direction, glowing pink and golden like magical waves. The energy spreads playfully across the street, scattering sparkles shaped like round fruity light. People scream and run away in exaggerated, comical ways some tripping, some flailing their arms, like a cheesy retro B-movie scene. The camera shakes with the impact, then tracks the peach energy as it shoots upward into the sky, absurd and surreal. Live-action cinematic style, vibrant neon glow, retro sci-fi parody vibe, funny and chaotic atmosphere."
    },
    {
        id: "google-imagen-23",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-23.png",
        variant: 'featured',
        prompt: "Dark infinite black background. A rustic wooden bowl is placed at the top of the frame with two freshly cut lemon halves inside. Below the bowl, a pair of human hands are gently holding fresh raspberries with drops of water and sprigs of mint. In a smooth cinematic motion, the hands lift and carefully pour the raspberries and mint leaves into the bowl, letting them fall on top of the two lemon halves. The lighting is soft and dramatic, highlighting the freshness of the fruits and herbs against the dark background. Ultra-realistic, high detail, organic, cinematic atmosphere."
    },
    {
        id: "google-imagen-24",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-24.png",
        variant: 'featured',
        prompt: "A lone dancer moving gracefully across the desert sands, wrapped in flowing desert robes and scarves, torso fully covered, realistic fabric movement caught in the wind, expressive slow dance under golden hour light, dramatic shadows stretching across the dunes, photorealistic details in fabric and skin, cinematic desert horizon backdrop, Shot on Nikon D850, AF-S NIKKOR 105mm f/1.4, ultra-detailed textures, hyper-realistic cinematic still"
    },
    {
        id: "google-imagen-25",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-25.png",

        prompt: "Ultra-realistic wide-angle action shot of a black horse with aviators , driving a red Ferrari Testarossa 1990 car at high speed on a Monza racing track . The horse is leaning forward with excitement, gripping the steering wheel tightly with a wide open-mouthed grin. Background features Monza crowd and italiana flags , with other racers blurred in motion. Captured with cinematic lighting, vibrant colors, dynamic motion blur, extreme sharpness on subject, immersive photography aesthetic."
    },
    {
        id: "google-imagen-26",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-26.png",

        prompt: "Soft glowing pastel floral buque with peonies and golden leaves, airy romantic light, luxury boutique café aesthetic"
    },
    {
        id: "google-imagen-27",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-27.png",

        prompt: "Static surveillance camera footage inside a dark corridor of a futuristic spaceship. The camera is fixed high on the ceiling, completely still, capturing the entire scene without movement. An astronaut walks slowly through the corridor, wearing a full space suit with a reflective helmet catching the cold neon lights. The atmosphere is eerie and quiet, with dim lighting and long shadows. The video has typical security camera glitches: visual static, horizontal scan lines, timestamp in the corner, and a slight greenish monochrome tone. Constant noise and interference give an old CCTV feel. The astronaut moves alone, evoking a sense of isolation and mystery."
    },
    {
        id: "google-imagen-28",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-28.png",

        prompt: "The Cowardly Lion, 3/4 view, head slightly tilted, steadicam, white background, minimalistic background, in the style of Ale Giorgini, the design is colorful, minimalistic, with bold lines and solid colors, and simple details. Alessandro Giorgini style, flat illustration of a cartoon design style penicillium, minimalistic vector illustration with clean lines"
    },
    {
        id: "google-imagen-29",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-29.png",

        prompt: "A cybernetic DJ console fused with analog retro devices (tapes, CDs, vinyls), glowing in metallic purple and neon lights, surrounded by digital fractals and cosmic energy, retrofuturistic electronic music aesthetic, dark immersive atmosphere."
    },
    {
        id: "google-imagen-32",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-32.png",

        prompt: "Instead of blaming circumstances, we empower ourselves by realizing that the power to change lies within us. Self-awareness and self-action lead to growth. a realistic sketch drawing of a man realizing self awareness the man and the body should move separately from the thought explosion"
    },
    {
        id: "google-imagen-31",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-31.png",
        variant: 'tall',
        prompt: "dreamlike photography, distant perspective from inside the room, showing a huge old computer with a glowing CRT screen. A woman in a dress is stepping into the monitor, one foot already inside the screen, as if crossing the threshold. Flowers float upward. Room's walls and ceiling are visible. Creative atmosphere, beautiful flowers, dramatic lights, minimalistic, sigma bf shot, 50mm, 4k"
    },
    {
        id: "google-imagen-30",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-30.png",

        prompt: "A hyper-realistic full-body photograph of a strange whimsical creature sitting sadly on a soaked cardboard box in a homeless camp. The creature has very large bulging eyes, sparse messy orange hair, smooth peach-colored skin with subtle wrinkles. Its arms and legs are short and stubby, with chubby non-human fingers and broad cartoon-like feet (not realistic human limbs). The creature wears a dirty, worn-out t-shirt. Its expression is sad, lips drooping, eyes wide and sorrowful. Around it are wet cardboard, plastic bags, an old blanket, and scattered trash. The atmosphere is melancholic but still surreal, documentary-style, ultra-detailed, 8K realism, cinematic lighting."
    },
    {
        id: "google-imagen-33",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-33.png",

        prompt: "The camera sweeps upward from the handbag swinging at her side to her face, then spins around in a dramatic 360° orbit as she struts forward like a runway show."
    },
    {
        id: "google-imagen-34",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-34.png",

        prompt: "A samurai in worn black armor, standing in the middle of a ruined temple, holding his katana raised with both hands, thick mist surrounding him, sparks and dust floating in the air, dramatic backlight with golden sunset light, vertical 9:16 framing, hyper-realistic cinematic style"
    },
    {
        id: "google-imagen-35",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-35.png",

        prompt: "CCTV surveillance footage style, ultra-realistic, grainy low-resolution security camera look. Multiple televisions on screen, each showing sequencers that flash or shift differently. One broken television displays glowing gold text 'ON!' and a small illustration of a lightning, the screen flickers on and off, glitch effect, eerie atmosphere"
    },
    {
        id: "google-imagen-36",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-36.png",
        variant: 'featured',
        prompt: "A monster sitting in a chair on blue background vector style"
    },
    {
        id: "google-imagen-37",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-37.png",

        prompt: "A close-up portrait of a young East Asian woman with porcelain skin and soft pink glossy lips, natural brown straight hair neatly parted with a few strands over the forehead, wearing a minimal makeup look with luminous highlights and subtle lashes, gently touching her cheek with slender fingers adorned with a thin silver ring, expression serene and elegant, studio setting with a clean white background and soft diffused lighting, captured in a high-resolution beauty editorial style with a clean and dewy aesthetic."
    },
    {
        id: "google-imagen-38",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-38.png",

        prompt: "a lookbook sketch marker and pen painting image of a young woman with hijab dressed in a 1961 mary tyler moore vibe, she is dressed in a spring green pants a cream blouse, she is the office queen, she is sitting at a mid century desk, under the desk is her briefcase, she is holding a cup of coffee, the office is mid century. Styled like an ad no clutter it focuses on her. This is a fashion design for Vogue Magazine. hard angular lines fashion style drawing."
    },
    {
        id: "google-imagen-39",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-39.png",

        prompt: "2D cartoon, close-up of a destroyed 1960s car at night, windshield shattered, faint smoke rising in eerie spirals, headlights flickering, drawn with horror comic book textures, muted colors with red accents, dramatic cinematic framing, unsettling retro vibe, without glowing eyes, not photorealistic"
    },
    {
        id: "google-imagen-40",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-40.png",

        prompt: "vintage travel brochure 1960s illustration of a smiling Pan Am astronaut in front of an Orion III on the Moon, elegant tourists sipping cocktails in Clavius Base, close-up of the Monolith on the lunar plain, scientists studying lunar samples, astronaut admiring Earth. Orion III in the foreground, Clavius Base in the background, isolated Monolith, diagonal lines suggesting movement, vanishing point towards the Monolith, realistic textures, precise details, optimism, wonder, mystery, nostalgia, futurism, sterile lunar surface, luxurious interior, infinite space, bright artificial lighting, metallic reflections, cast shadows, bright color palette (blue, orange, yellow), touches of black and white, inspired by golden age aviation art, vintage travel posters, 1960s science fiction, Stanley Kubrick, and Arthur C. Clarke."
    },
    {
        id: "google-imagen-41",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-41.png",

        prompt: "3D illustration of a futuristic city of Oslo on an iPhone in a hand, with a hologram floating above it featuring three-dimensional icons and buildings flying around. Green energy is flowing from one building to another through blue light tubes. The background is yellow, with an isometric view and a 20mm lens. The image has soft shadows, hyper-detailed cinematic quality, and vibrant colors."
    },
    {
        id: "google-imagen-42",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-42.png",

        prompt: "A cozy, close-up photograph with a shallow depth of field. A dark ceramic mug filled with black coffee sits on a rustic, dark wood table. A delicate plume of white steam rises from the hot coffee. In the blurred background, a large windowpane is covered in realistic raindrops, with the cool, grey light of a rainy day visible outside. The mood is warm, peaceful, and comforting (hygge)."
    },
    {
        id: "google-imagen-43",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/gallery-43.png",

        prompt: "A classic, black and white, film noir scene. A world-weary private detective in a suit and loosened tie sits in his dark, messy office late at night. He is in silhouette, but a single, sharp beam of light cuts through the darkness from a window with Venetian blinds, dramatically illuminating the thick, curling plume of smoke rising from the cigarette in his hand. The smoke is the brightest element in the frame. Through the window, the faint, out-of-focus silhouette of a 1940s city skyline is visible."
    }

];

const textImageToImageGalleryItems: ImageGalleryItem[] = [
    {
        id: "google-imagen-edit-1",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-1.png",

        prompt: "Transform this into a photorealistic picture of an astronaut in a helmet and full suit dunking a basketball in an overgrown basketball court in the rainforest.",
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-2.jpg", "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-1.jpg"]
    },
    {
        id: "google-imagen-edit-2",
        width: 1536,
        height: 2816,
        aspect_ratio: "9:16",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-2.png",

        prompt: "Make this image a minimalist living room with white walls, a large bright window, a dark blue sofa with dark blue throw pillows, a tall dark blue vase with light green leaves, and a dark blue patterned rug on a concrete floor. The style is clean, modern, and simple.",
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-3.jpg"]
    },
    {
        id: "google-imagen-edit-3",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-3.png",

        prompt: "Transform this into a person falling and dropping a 3 tiered cake.",
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-4.png"]
    },
    {
        id: "google-imagen-edit-4",
        width: 1536,
        height: 2816,
        aspect_ratio: "9:16",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-4.png",

        prompt: "A model is posing and leaning against a pink bmw. She is wearing the following items, the scene is against a light grey background. The green alien is a keychain and it's attached to the pink handbag. The model also has a pink parrot on her shoulder. There is a pug sitting next to her wearing a pink collar and gold headphones.",
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-5.png",
            "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-6.png",
            "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-7.png"
        ]
    },
    {
        id: "google-imagen-edit-5",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-5.png",

        prompt: "A photo-realistic version of the provided image, featuring portraits of historical figures rendered with vibrant and natural colors, enhancing their features and clothing.",
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-9.webp"]
    },
    {
        id: "google-imagen-edit-6",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-6.png",

        prompt: "A colorful version of the provided image, featuring portraits of historical figures rendered with vibrant and natural colors, enhancing their features and clothing.",
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-8.png"]
    },
    {
        id: "google-imagen-edit-7",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-7.png",

        prompt: "you are a location-based AR experience generator. highlight [point of interest] in this image and annotate relevant information about it.",
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-10.jpeg"]
    },
    {
        id: "google-imagen-edit-8",
        width: 2816,
        height: 1536,
        aspect_ratio: "16:9",
        src: "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-8.png",

        prompt: `Generate an X-ray view of the image to reveal the interior of the building.
Use an AR experience generator to visualize hidden structures.
Highlight each point and attach a concise label.
Ensure labels are informative and easy to understand`,
        referenceImages: ["https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-11.jpeg"]
    }
];

const allTextImageToImage: string[] = [
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-1.jpg",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-2.jpg",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-3.jpg",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-4.png",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-5.png",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-6.png",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-7.png",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-8.png",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-9.webp",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-10.jpeg",
    "https://cdn.aibrush.co/docs/images/models/google-imagen/edit-gallery-11.jpeg"
];

export default function GoogleImagenPage() {
    return (
        <div {...stylex.props(styles.modelPage)}>
            {/* Header Navigation */}
            <Link to="/" {...stylex.props(styles.backLink)}>
                <ArrowLeft size={20} />
                Back to Home
            </Link>

            {/* Hero Section */}
            <section {...stylex.props(styles.heroSection)}>
                <div {...stylex.props(styles.heroBackground)}>
                    <img
                        src={MODEL_CONFIG.heroBgImage}
                        {...stylex.props(styles.heroBgImage)}
                        alt={`${MODEL_CONFIG.name} hero image`}
                    />
                    <div {...stylex.props(styles.heroOverlay)}></div>
                </div>
                <div {...stylex.props(styles.heroContent)}>
                    <h2 {...stylex.props(styles.heroTitle)}>{MODEL_CONFIG.name.toUpperCase()}</h2>
                    <p {...stylex.props(styles.heroDescription)}>
                        Best for <strong>Creative Expression</strong>, Experience cutting-edge AI image generation with <strong>Text to Image</strong> and <strong>Text & Image to Image</strong> capabilities.
                        <br />
                        Powered by <a href={MODEL_CONFIG.providerUrl} target="_blank" rel="noopener noreferrer">{MODEL_CONFIG.providerName}</a>
                    </p>
                    <div {...stylex.props(styles.heroStats)}>
                        <div {...stylex.props(styles.stat)}>
                            <Image size={20} />
                            <span>Text to Image</span>
                        </div>
                        <div {...stylex.props(styles.stat)}>
                            <Image size={20} />
                            <span>Text & Image to Image</span>
                        </div>
                    </div>
                    <div {...stylex.props(styles.creditCostBadge)}>{MODEL_CONFIG.creditsPerImage} credits per image</div>
                </div>
            </section>

            {/* Image Gallery */}
            <TextToImageGallery
                modelKey={MODEL_CONFIG.modelKey}
                modelLabel={MODEL_CONFIG.name}
                modelNote={`This model costs <strong>${MODEL_CONFIG.creditsPerImage} credits</strong> per image.`}
                title="Text to Image Gallery"
                description={`Explore the exceptional capabilities of <a href='https://deepmind.google/models/imagen/' target='_blank' rel='noopener noreferrer'>${MODEL_CONFIG.name} 4</a> through these AI-generated images. <strong>Click on any image</strong> to see how it was created.`}
                items={textToImageGalleryItems} />

            {/* Text & Image to Image Gallery */}
            <TextImageToImageGallery
                modelKey={MODEL_CONFIG.modelKey}
                modelLabel={MODEL_CONFIG.shortName}
                modelNote={`This model costs <strong>${MODEL_CONFIG.creditsPerImage} credits</strong> per image.`}
                title="Text & Image to Image Gallery"
                description="The best image editing model with <a href='https://blog.google/products/gemini/updated-image-editing-model/' target='_blank' rel='noopener noreferrer'>Nano Banana 🍌</a> in-context editing capabilities. This model excels at <strong>creative transformations</strong>, <strong>style transfer</strong>, and <strong>artistic enhancement</strong> while maintaining the original image's core structure. <strong>Click on any image</strong> to see how it was created."
                items={textImageToImageGalleryItems}
                allImages={allTextImageToImage}
            />
        </div>
    )
}
